/**
 * EVENT_DOMAINS defines a logical group for UI events
 */
export var EVENT_DOMAINS = {
  GENERAL: 'GENERAL',
  GAME: 'GAME',
  MISSIONS: 'MISSIONS',
  ACTIONS_COMMANDS: 'ACTION_COMMANDS'
};